import lodash from 'lodash'
import qs from 'querystring'
export * from './decorators'
export * from './api'

/**
 * 
 * @param {string | string[]} key 
 */
function checkAuth (key) {
  if (Array.isArray(key)) {
    return (key.filter(k => lodash.get(this, `props.context.authority[${k}]`)).length > 0)
  } else return lodash.get(this, `props.context.authority[${key}]`)
}
function filterColumnsByAuth (columns) {
  if (!this.checkAuth) {
    throw new Error('使用column的话必须mixin checkAuth')
  }
  return columnGenerator(columns).filter(column => {
    if (column.authKey) {
      if (!this.checkAuth(column.authKey)) {
        return false
      }
    }
    return true
  })
}
function columnGenerator (config) {
  return config.map((item, idx) => {
    if (!item.width) {
      item.width = 80
    }
    item.key = idx
    return item
  })
}
/**
 * 自己注入了全部的选项
 * @param {{id: number, name: string}[]} list 
 */
function convertSelectionDataType (list) {
  return /*[{value: '', name: '全部'}].concat*/Array.isArray(list) ? (list.map(({id, name}) => {
    return {
      value: id,
      name,
    }
  })) : undefined
}


/**
 */
function setSearch (obj) {
  const search = getSearch()
  function stringify (obj) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = JSON.stringify(obj[key])
      return newObj
    }, {})
  }
  window.history.replaceState(
    null,
    null,
    `${window.location.pathname}#${qs.stringify(Object.assign({}, stringify(search), stringify(obj)))}`
  )
}
/**
 */
function getSearch () {
  let search = {}
  if (window.location.hash)
    search = qs.parse(window.location.hash.replace(/^#/, ''))
  return Object.keys(search).reduce((obj, key) => {
    try {
      obj[key] = JSON.parse(search[key])
    }catch(e){
      obj[key] = search[key]
    }
    return obj
  }, {})
}
function recordValuesChange (values) {
  setSearch({
    filterValues: values
  })
}
export {
  checkAuth,
  getSearch,
  setSearch,
  recordValuesChange,
  filterColumnsByAuth,
  columnGenerator,
  convertSelectionDataType,
}